// insight-actions.js

import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPricingAnalyticsWCA, getMessageAnalyticsWCA } from '../../../api/wca/insight.services';

export const getPricingAnalytics = createAsyncThunk(
  'insight/getPricingAnalytics',
  async ({ metadataId, fromDate, toDate }, { rejectWithValue }) => {
    try {
      const res = await getPricingAnalyticsWCA(metadataId, fromDate, toDate);

      const points = (res?.pricing_analytics?.data || []).flatMap(
        (entry) => entry.data_points || [],
      );

      return points;
    } catch (err) {
      return rejectWithValue(err?.response?.data || 'Failed to fetch pricing analytics');
    }
  },
);

export const getMessageAnalytics = createAsyncThunk(
  'insight/getMessageAnalytics',
  async ({ metadataId, fromDate, toDate }, { rejectWithValue }) => {
    try {
      const res = await getMessageAnalyticsWCA(metadataId, fromDate, toDate);
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data || 'Failed to fetch message analytics');
    }
  },
);
